import { useUiStore } from "@/stores/UiStore";
import { useEffect } from "react";

export default function useWideLayout(isWide = true) {
  useEffect(() => {
    useUiStore.setState({ wideLayout: isWide });
    return () => {
      useUiStore.setState({ wideLayout: false });
    };
  }, [isWide]);
}
